// 导入所有API模块
import * as loginAPI from './login.js';
// 企业官网后台首页相关API
import * as adminHomeAPI from './admin/home.js';
// 认证相关
import * as authAPI from "./admin/auth.js";
// 订单相关
import * as orderAPI from "./admin/order.js";
// 文章相关
import * as articleAPI from "./admin/article.js";
// 推文相关
import * as tweetAPI from "./admin/tweet.js";
// 产品中心模块相关API接口
import * as productAPI from "./enterprise/product.js";
// 企业官网首页相关API
import * as homeAPI from "./enterprise/home.js";
// 模版相关
import * as modulesAPI from "./admin/modules.js";
// 活动管理相关
import * as activeAPI from "./admin/active.js";
// 用户管理相关
import * as userAPI from "./admin/user.js";
//公众号管理菜单相关
import * as wechatOfficialAccountAPI from "./admin/WeChatOfficialAccount.js";

// 可以继续导入其他API模块

// 整合所有API
const api = {
  // 登录相关API
  login: loginAPI,
  // 企业官网后台首页相关API
  admin: {
    home: adminHomeAPI,
    order: orderAPI,
    article: articleAPI,
    tweet: tweetAPI,
    modules: modulesAPI,
    active: activeAPI,
    user: userAPI,
    // 公众号管理菜单相关API接口
    wechatOfficialAccount: wechatOfficialAccountAPI,
  },
  // 企业官网首页相关API
  home: {
    getHomeBannerAPI: homeAPI.getHomeBannerAPI,
  },
  auth: authAPI,
  // 企业官网产品中心模块相关API接口
  product: productAPI,
  // 可以继续添加其他模块
};

export default api;